import React, { useEffect, useState, useCallback } from 'react'
import Table from '../../common/Table';
import { convertIstToUtc } from '../../common/TimeUtils';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment-timezone';
import { getClassesEarning } from '../../redux/services/contestEarningSlice';

const ClassesEarning = () => {
    const dispatch = useDispatch();
    const [toggle, setToggle] = useState(false);
    const [savedStartDate, setSavedStartDate] = useState(null);
    const [savedEndDate, setSavedEndDate] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const classesEarning = useSelector(
      (state) => state.contestEarning.classesEarningData
    );
    const handleDateSubmit = () => {
      let adjustedStartDate = null;
      if (startDate) {
        adjustedStartDate = new Date(startDate);
        adjustedStartDate.setHours(0, 0, 0, 0);
      }
  
      let adjustedEndDate = null;
      if (endDate) {
        adjustedEndDate = new Date(endDate);
        adjustedEndDate.setHours(23, 59, 59, 999);
      }
      const SDate = adjustedStartDate ? convertIstToUtc(adjustedStartDate) : null;
      const EDate = adjustedEndDate ? convertIstToUtc(adjustedEndDate) : null;
      if (SDate && EDate) {
        setToggle(false);
        getAllSlotTimeEarning(SDate, EDate);
        setStartDate(
          convertIstToUtc(moment().subtract(24, "hours").toISOString())
        );
        setEndDate(convertIstToUtc(moment().toISOString()));
      } else {
      }
      return { SDate, EDate };
    };
    const handleSaveDate = () => {
      setSavedStartDate(startDate);
      setSavedEndDate(endDate);
      if (handleDateSubmit) {
        handleDateSubmit();
      }
    };
    const getAllSlotTimeEarning = useCallback(
      async (startDate, endDate) => {
        const SDate = startDate
          ? startDate
          : convertIstToUtc(moment().subtract(24, "hours").toISOString());
        const EDate = endDate ? endDate : convertIstToUtc(moment().toISOString());
        const payload = { startDate: SDate, endDate: EDate };
        try {
          const response = await dispatch(getClassesEarning(payload));
          if (response.payload.status === 200) {
            setStartDate("");
            setEndDate("");
          }
        } catch (error) {}
      },
      [dispatch]
    );
  
    useEffect(() => {
      getAllSlotTimeEarning();
    }, [getAllSlotTimeEarning]);
    const columns = [
      {
        header: "S/N",
        key: "index",
        render: (_, __, index) => index + 1,
      },
      { header: "Name", key: "name" },
      { header: "Join Contest", key: "joinContest" },
      { header: "Contest Count ", key: "contestCount" },
      { header: "Earning ", key: "earnings" },
      { header: "Ref Students ", key: "refferalStudents" },
    ];
    const handleClearDates = () => {
      setStartDate("");
      setEndDate("");
      setSavedStartDate("");
      setSavedEndDate("");
      if (handleDateSubmit) {
        handleDateSubmit();
      }
    };
    return (
      <div>
        <Table
          title="Classes Earning"
          columns={columns}
          data={classesEarning}
          dateFilter={true}
          toggle={toggle}
          setToggle={setToggle}
          savedStartDate={savedStartDate}
          savedEndDate={savedEndDate}
          handleClearDates={handleClearDates}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          handleSaveDate={handleSaveDate}
          startDate={startDate}
          endDate={endDate}
        />
      </div>
    )
}

export default ClassesEarning